export function BoqBarLabel({ x, y, width, value }: any) {
  if (!value || Number(value) === 0) return null
  const display =
    Number(value) >= 1_000_000
      ? `₪${(Number(value) / 1_000_000).toFixed(1)}M`
      : Number(value) >= 1_000
        ? `₪${(Number(value) / 1_000).toFixed(0)}K`
        : `₪${Number(value).toFixed(0)}`
  return (
    <text
      x={Number(x) + Number(width) / 2}
      y={Number(y) - 5}
      fill='#374151'
      fontSize={11}
      fontWeight={600}
      textAnchor='middle'
    >
      {display}
    </text>
  )
}
